<script setup>
import emitter from "@/utils/bus"; // 通信对象
import { ref } from "vue";
import closeIcon from "@/assets/icon/close.svg";
import { appHapticFeedback } from "@/utils/common";
import { useConfigStore } from "@/store/config";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const config = useConfigStore();
const isShow = ref(false);

emitter.on("showAboutCoin", (res) => {
  isShow.value = res;
});

let close = () => {
  isShow.value = false;
  appHapticFeedback();
};
</script>

<template>
  <div class="view" v-show="isShow">
    <div class="language">
      <div class="top">
        <div class="top_title">{{ config.app_coin_name }}</div>
        <div class="close" @click="close">
          <img :src="closeIcon" alt="" />
        </div>
      </div>
      <div class="content">
        {{ config.app_coin_desc }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/surfaces" as surface;

.view {
  @include surface.dialog-overlay;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  backdrop-filter: blur(5px);
  .language {
    @include surface.dialog-panel;
    background: #1e1e1e;
    display: block;
    border: #2d2d2d solid 1px;

    .content {
      margin-top: 8px;
      margin-bottom: 8px;
      font-size: 14px;
      line-height: 1.6;
      //overflow-y: auto;
      max-height: 70vh;
      color: #fff;
      white-space: pre-wrap;
      //text-align: center;
    }

    .top {
      @include surface.dialog-header;
      position: relative;

      .close {
        @include surface.close-button;
        img {
          width: 100%;
          height: 100%;
        }
      }

      &_title {
        @include surface.title;
        width: auto;
        font-weight: bold;
        color: #fff;
      }

      &_introduced {
        color: #fff;
        font-size: 4vw;
      }
    }
  }
}
.view .language .top .close img {
  width: 24px;
  height: 24px;
}
</style>
